import reduceReducers from 'reduce-reducers';
import { initialState } from '@modules/documents/children/upload/store';
import { documentUpload } from './document-upload';
import { getFormFields } from './get-form-fields';
import { setFileName } from './set-file-name';

export const documentsUploadRootReducer = reduceReducers(initialState, documentUpload, getFormFields, setFileName);
